import styled from 'styled-components';

import CarvanaLogo from '../assets/logo-flat-64.png';
import CarvanaHeaderLogo from '../assets/carvana.svg';
import CongratsTrophyIcon from '../assets/congrats-trophy.gif';
import BellNotificationIcon from '../assets/dashboard/bell-notification.gif';
import WarningBellIcon from '../assets/dashboard/warning-bell.svg';
import CheckmarkIcon from '../assets/dashboard/checkmark.svg';
import ErrorNotificationIcon from '../assets/dashboard/error.gif';
import DashboardCarvanaCareIcon from '../assets/dashboard/db-carvana-care.svg';
import DashboardCashFinanceIcon from '../assets/dashboard/db-cash-finance.svg';
import DashboardDeliveryPickupIcon from '../assets/dashboard/db-delivery-pickup.svg';
import DashboardDriversLicenseIcon from '../assets/dashboard/db-drivers-license.svg';
import DashboardKiqIcon from '../assets/dashboard/db-kiq.svg';
import DashboardPaymentIcon from '../assets/dashboard/db-payment.svg';
import DashboardPersonalInfoIcon from '../assets/dashboard/db-personal-info.svg';
import DashboardScheduleIcon from '../assets/dashboard/db-schedule.svg';
import DashboardTradeInIcon from '../assets/dashboard/db-tradein.svg';
import DashboardProgressActive from '../assets/dashboard/icn-progress-active-18.svg';
import PurchaseHeaderLogo from '../assets/purchase-header-logo.svg';
import PurchaseHeaderClock from '../assets/purchase-header-clock.svg';
import PurchaseHeaderCart from '../assets/purchase-header-cart.svg';
import ListIcon from '../assets/ListIcon.svg';
import CarvanaLogoHorizontal from '../assets/CarvanaLogoHorizontal.svg';
import DocumentUpload from '../assets/doc-upload.svg';
import CloseIcon16px from '../assets/close16px.svg';

import MenuHouseIcon from '../assets/menu-house.svg';
import MenuExitIcon from '../assets/menu-exit.svg';
import MenuSearchIcon from '../assets/menu-search.svg';
import MenuUserIcon from '../assets/menu-user.svg';
import MenuVdpIcon from '../assets/menu-vdp.svg';
import NavBackIcon from '../assets/nav-back.svg';

import PaymentDialsIcon from '../assets/payment/pp-dials.png';
import PaymentSlidersIcon from '../assets/payment/pp-sliders.png';
import PaymentCashIcon from '../assets/payment/pp-cash.png';
import PaymentBankIcon from '../assets/payment/pp-bank.png';
import PaymentBankIconNext from '../assets/payment/bank.svg';
import Payment90DayFinanceBannerIcon from '../assets/payment/pp-90DayFinanceBanner.svg';

import HourglassNotificationIcon from '../assets/icon-hourglass-anim.gif';
import StopHandIcon from '../assets/stop-hand.svg';
import LockedIcon from '../assets/lock.svg';
import LockedIconWhite from '../assets/lock-white.svg';
import UnLockedIcon from '../assets/unlocked.svg';
import MailIcon from '../assets/mail_outline_48px.svg';
import BoldChatIcon from '../assets/boldchat-mobile-icon.png';
import CartIcon from '../assets/cart.svg';
import CartWithExclamation from '../assets/cart-with-exclamation.svg';
import PauseIcon from '../assets/pause_48px.svg';
import Plane from '../assets/plane.svg';
import CarvanaClubLogo from '../assets/carvana-club-logo.svg';
import CarvanaCareIcon from '../assets/carvana-care-logo.svg';
import PowertrainIcon from '../assets/powertrain-logo.svg';
import Plaid from '../assets/plaid.svg';
import PlaidAlt from '../assets/plaid-alt.svg';
import SecuredPlaid from '../assets/secured-plaid.svg';
import SecuredPlaidTop from '../assets/secured-plaid-top.svg';
import DashedLine from '../assets/dashed-line.svg';

import CarvanaCar from '../assets/ancillary-products/carvana-car.png';
import DriveAxle from '../assets/ancillary-products/driveaxle.png';
import Engine from '../assets/ancillary-products/engine.png';
import FlatTire from '../assets/ancillary-products/flat-tire.png';
import GasCan from '../assets/ancillary-products/gas.png';
import JumpStart from '../assets/ancillary-products/jump-start.png';
import LockSmith from '../assets/ancillary-products/locksmith.png';
import Towing from '../assets/ancillary-products/towing.png';
import TransferCase from '../assets/ancillary-products/transfercase.png';
import Transmission from '../assets/ancillary-products/transmission.png';
import PaymentDetailsCheckIcon from '../assets/check.svg';
import CarvanaCarSad from '../assets/carvana-car-sad.svg';
import SadCar from '../assets/sad-car.svg';
import Close from '../assets/close.svg';
import PhoneWhite from '../assets/phone_white_96x96.png';
import Clock from '../assets/clock.svg';
import MegaphoneIcon from '../assets/megaphone.svg';
import AppleStoreIcon from '../assets/apple-app-store-badge.svg';
import GoogleStoreIcon from '../assets/google-play-badge.svg';
import Alarm from '../assets/alarm.svg';

import CongratsModalAccidentFree from '../assets/congratsModalAccidentFree.png';
import CongratsModalDuoCheck from '../assets/congratsModalDuoCheck.png';
import CongratsModalPhone from '../assets/congratsModalPhone.png';

import CustomerInfo from '../assets/customer-info.svg';
import Bank from '../assets/bank.svg';
import BankSmall from '../assets/bank-small.svg';
import CheckIcon from '../assets/check-icon.svg';

import QRCodeAppStore from '../assets/mobile-app-redirect/qrcode-redirectToStore.png';
import AppleStoreIconBadge from '../assets/mobile-app-redirect/apple-app-store.png';
import GoogleStoreIconBadge from '../assets/mobile-app-redirect/google-play-store.png';
import HaulerAndPhone from '../assets/mobile-app-redirect/hauler-and-phone.png';
import PhoneDriversLicense from '../assets/mobile-app-redirect/phone-drivers-license.png';
import CartHeartIcon from '../assets/mobile-app-redirect/cartHeart.png';

import BarsIcon from './bars';
import BarsToCloseIcon from './bars-to-close';
import Brackets from '../assets/brackets.svg';
import PhoneIcon from './phone';
import NoEvoxImage from '../assets/noevox.png';
import Yes from '../assets/ancillary-products/yes.svg';
import Nope from '../assets/ancillary-products/nope.svg';
import IconTooltip from '../assets/ancillary-products/icon-tooltip.svg';
import IconInfoTooltip from '../assets/ancillary-products/icon-info-tooltip.svg';
import CarvanaCareEssentialNew from '../assets/ancillary-products/carEssential.png';
import CarvanaCarePlusNew from '../assets/ancillary-products/carPlus.png';
import CarvanaCarePremierNew from '../assets/ancillary-products/carPremier.png';
import CarvanaCareEssentialLogo from '../assets/ancillary-products/CarvanaCare-Essential.svg';
import CarvanaCarePlusLogo from '../assets/ancillary-products/CarvanaCare-Plus.svg';
import CarvanaCarePremierLogo from '../assets/ancillary-products/CarvanaCare-Premier.svg';
import Bolt from '../assets/ancillary-products/Bolt.svg';
import CheckMarkWhite from '../assets/ancillary-products/check-white.svg';
import CheckMarkGray from '../assets/ancillary-products/check-gray.svg';
import CheckMarkBlue from '../assets/ancillary-products/check-blue.svg';
import CheckMarkYellow from '../assets/ancillary-products/check-yellow.svg';
import PriceDropIcon from '../assets/ancillary-products/PriceDropIcon.svg';
import BulletPoint from '../assets/ancillary-products/BulletPoint.svg';
import CarrotDown from '../assets/ancillary-products/carrot-down.svg';
import CarrotDownWhite from '../assets/ancillary-products/carrot-down-white.svg';
import CarrotUp from '../assets/ancillary-products/carrot-up.svg';
import CarrotUpWhite from '../assets/ancillary-products/carrot-up-white.svg';
import CoinMoneySignArrows from '../assets/CoinMoneySignArrows.svg';
import CoveredItem from '../assets/ancillary-products/check.svg';
import StarIcon from '../assets/ancillary-products/star.svg';
import AncillaryProductsDeductible from '../assets/ancillary-products/deductible.png';
import AncillaryProductsRoadside from '../assets/ancillary-products/roadside.png';
import AncillaryProductsServiceMap from '../assets/ancillary-products/servicemap.png';
import DisabledCareEssential from '../assets/ancillary-products/disabledCarEssential.png';
import DisabledCarePlus from '../assets/ancillary-products/disabledCarPlus.png';
import DisabledCarePremier from '../assets/ancillary-products/disabledCarPremier.png';
import Carrot from '../assets/ancillary-products/carrot.svg';
import TooltipSmall from '../assets/ancillary-products/tooltipSmall.png';
import GapWaiverCar from '../assets/gapWaiver/gap-waiver-car.png';
import GapWaiverCaution from '../assets/gapWaiver/gap-waiver-caution.png';
import GapWaiverCheck from '../assets/gapWaiver/gap-waiver-check.png';
import GapWaiverCoverageCheck from '../assets/gapWaiver/gap-waiver-coverage-check.png';
import CalendarIcon from '../assets/calendar-icon.svg';
import GetValue from '../assets/GetValue.png';
import HaulerPic from '../assets/HaulerAndCar.png';
import VendingMachinePic from '../assets/VendingMachine.png';
import ThirdPartyDeliveryPic from '../assets/ThirdPartyDelivery.png';
import VehicleUnavailable from '../assets/VehicleUnavailable.png';
import DollarSignIcon from '../assets/DollarSign.png';
import MoneyIcon from '../assets/IcoMoney.png';
import BankIcon from '../assets/Bank.png';
import ToolTipStandard from '../assets/TooltipStandard.png';
import Popular from '../assets/Popular.png';
import Pin from '../assets/Pin.png';
import Delivery from '../assets/Delivery.png';
import Edit from '../assets/Edit.png';
import BrokenMap from '../assets/Map.png';
import VehicleSide from '../assets/VehicleSide.png';
import Caution from '../assets/Caution.png';
import CautionIco from '../assets/Ico-Caution.svg';
import MapMarker from '../assets/mapmarker.svg';
import Flash from '../assets/flash.svg';
import Star from '../assets/star.svg';
import Fire from '../assets/fire.svg';
import ArrowDown from '../assets/Ico-SmallArrowDown.svg';
import ToolTipExclamation from '../assets/Ico-InformationStandard.svg';
import Money from '../assets/Ico-Money.svg';
import DocError from '../assets/Ico-DocError.svg';
import IdIcon from '../assets/Ico-ID.svg';
import DocUploadIcon from '../assets/icon-doc-upload.svg';
import AdjustmentIcon from '../assets/Adjustment.svg';
import ArrowDownIcon from '../assets/Ico-ArrowDown.svg';
import TradeInIcon from '../assets/Tradein.svg';
import PeopleIcon from '../assets/People.svg';
import CoastToCoast from '../assets/CoastToCoast-56px.svg';
import DottedLine from '../assets/DottedLine.svg';
import HomeIcon from '../assets/Home-new.svg';
import Vending from '../assets/Vending.svg';
import HaulerW231 from '../assets/HaulerW231.png';
import HaulerW365 from '../assets/HaulerW365.png';
import PriceDrop from '../assets/PriceDrop.svg';
import BodyStyle from '../assets/BodyStyle.svg';
import MoneyKeys from '../assets/MoneyKeys.svg';

import CoSigner from '../assets/cosignor.svg';
import MoneySparkles from '../assets/money_sparkles.svg';
import LocationPin from '../assets/pin.svg';
import CarvanaCarePlusTerms from '../assets/carvana-care-plus-terms.svg';

import AlertCircle from './AlertCircle';
import CheckCircle from './CheckCircle';
import OutlineCircle from './OutlineCircle';
import NewGapWaiverCar from '../assets/gapWaiver/new-gap-waiver-car.png';
import ShieldCheckMark from '../assets/gapWaiver/shield-check-mark.png';
import GreenCheck from '../assets/GreenCheck.svg';

import SevenDayMoney from '../assets/SevenDayMoney.svg';

import EncircledLicense from '../assets/drivers-license/encircled-license.svg';

// identity step
import SecuredLock from '../assets/identity/secured-lock.svg';
import ToolTipStandardSvg from '../assets/identity/TooltipStandard.svg';

import Stopwatch from '../assets/stopwatch.svg';
import SaveOptions from '../assets/save-options.svg';

import Refresh from '../assets/insurance/refresh.png';
import CarvanaRootInsurance from '../assets/insurance/carvana-root-insurance.svg';
import RootLogoGroup from '../assets/insurance/root-logo-group.svg';
import GabiLogoGroup from '../assets/insurance/gabi-logo-group.svg';
import ProgressiveLogoGroup from '../assets/insurance/progressive-logo-group.svg';
import UploadInsurance from '../assets/insurance/upload-insurance.svg';

import NotarizeLogo from '../assets/notarize-logo.png';
import ODOExample from '../assets/ODOExample.png';

// doc upload
import CaretRightEnabled from '../assets/CaretRightEnabled.svg';
import CaretRightDisabled from '../assets/CaretRightDisabled.svg';
import CaretLeftEnabled from '../assets/CaretLeftEnabled.svg';
import CaretLeftDisabled from '../assets/CaretLeftDisabled.svg';
import Trash from '../assets/Trash.svg';

// NewShowroomIcons Please use SVG
import Attached from '../assets/showroom/attach-24px.svg';
import ArrowLeftSmall from '../assets/showroom/arrow-left-16px.svg';
import ArrowLeftLarge from '../assets/showroom/arrow-left-24px.svg';
import CaretRight from '../assets/showroom/caret-right-24px.svg';
import CheckFilled from '../assets/showroom/check-filled-24px.svg';
import CloseLarge from '../assets/showroom/close-24px.svg';
import CloseSmall from '../assets/showroom/close-16px.svg';
import Document from '../assets/showroom/document-24px.svg';
import Download from '../assets/showroom/download-24px.svg';
import DuoCheck from '../assets/showroom/duo-check-32px.svg';
import ErrorFilled from '../assets/showroom/error-filled-24px.svg';
import ErrorOutlined from '../assets/showroom/error-outlined-24px.svg';
import InformationFilled from '../assets/showroom/information-filled-24px.svg';
import InformationStandard from '../assets/showroom/information-standard-24px.svg';
import Lightbulb from '../assets/showroom/lightbulb-24px.svg';
import SendSmall from '../assets/showroom/send-16px.svg';
import SendLarge from '../assets/showroom/send-24px.svg';
import CheckLarge from '../assets/showroom/check-large-16px.svg';
//Transfer Method
import HaveItDeliveredSmall from '../assets/transfer-method/have-it-delivered-small.jpg';
import HaveItDeliveredLarge from '../assets/transfer-method/have-it-delivered-large.jpg';

const CarvanaCarIcon = styled.img.attrs({
  src: CarvanaCar,
  alt: 'Carvana Car '
})``;
const DriveAxleIcon = styled.img.attrs({ src: DriveAxle, alt: 'Drive Axle' })``;
const EngineIcon = styled.img.attrs({ src: Engine, alt: 'Engine' })``;
const FlatTireIcon = styled.img.attrs({ src: FlatTire, alt: 'Flat Tire' })``;
const GasCanIcon = styled.img.attrs({ src: GasCan, alt: 'Gas Can' })``;
const JumpStartIcon = styled.img.attrs({ src: JumpStart, alt: 'Jump Start' })``;
const LockSmithIcon = styled.img.attrs({ src: LockSmith, alt: 'Lock Smith' })``;
const TowingIcon = styled.img.attrs({ src: Towing, alt: 'Towing' })``;
const TransferCaseIcon = styled.img.attrs({
  src: TransferCase,
  alt: 'Transfer Case'
})``;
const TransmissionIcon = styled.img.attrs({
  src: Transmission,
  alt: 'Transmission'
})``;
import PdfIcon from '../assets/PDF.svg';
import PhotoIcon from '../assets/Photo.svg';

export {
  CarvanaLogo,
  CarvanaClubLogo,
  CarvanaHeaderLogo,
  PurchaseHeaderLogo,
  BellNotificationIcon,
  WarningBellIcon,
  CheckmarkIcon,
  CheckMarkBlue,
  CheckMarkYellow,
  PriceDropIcon,
  BulletPoint,
  CarrotUpWhite,
  CarrotDownWhite,
  ErrorNotificationIcon,
  DashboardCarvanaCareIcon,
  DashboardCashFinanceIcon,
  DashboardDeliveryPickupIcon,
  DashboardDriversLicenseIcon,
  DashboardKiqIcon,
  DashboardPaymentIcon,
  DashboardPersonalInfoIcon,
  DashboardScheduleIcon,
  DashboardTradeInIcon,
  DashboardProgressActive,
  DocumentUpload,
  BarsIcon,
  BarsToCloseIcon,
  PhoneIcon,
  PhoneWhite,
  MenuHouseIcon,
  MenuExitIcon,
  MenuSearchIcon,
  MenuUserIcon,
  MenuVdpIcon,
  HourglassNotificationIcon,
  StopHandIcon,
  Stopwatch,
  NavBackIcon,
  LockedIcon,
  LockedIconWhite,
  UnLockedIcon,
  MailIcon,
  BoldChatIcon,
  CartIcon,
  CartWithExclamation,
  PauseIcon,
  PaymentDialsIcon,
  PaymentSlidersIcon,
  PaymentBankIcon,
  PaymentBankIconNext,
  PaymentCashIcon,
  Payment90DayFinanceBannerIcon,
  PhoneDriversLicense,
  Plane,
  CarvanaCareIcon,
  PowertrainIcon,
  CarvanaCarIcon,
  DriveAxleIcon,
  EngineIcon,
  FlatTireIcon,
  GasCanIcon,
  JumpStartIcon,
  LockSmithIcon,
  TowingIcon,
  TransferCaseIcon,
  TransmissionIcon,
  CarvanaCarSad,
  SadCar,
  PaymentDetailsCheckIcon,
  Close,
  MegaphoneIcon,
  AppleStoreIcon,
  GoogleStoreIcon,
  Alarm,
  CongratsTrophyIcon,
  CustomerInfo,
  Bank,
  BankSmall,
  Plaid,
  PlaidAlt,
  SecuredPlaid,
  SecuredPlaidTop,
  DashedLine,
  CheckIcon,
  QRCodeAppStore,
  AppleStoreIconBadge,
  GoogleStoreIconBadge,
  HaulerAndPhone,
  CartHeartIcon,
  NoEvoxImage,
  Yes,
  Nope,
  IconTooltip,
  IconInfoTooltip,
  CarvanaCareEssentialNew,
  CarvanaCarePlusNew,
  CarvanaCarePremierNew,
  CarvanaCareEssentialLogo,
  CarvanaCarePlusLogo,
  CarvanaCarePremierLogo,
  Bolt,
  CheckMarkWhite,
  CheckMarkGray,
  CarrotUp,
  CarrotDown,
  CoveredItem,
  StarIcon,
  AncillaryProductsDeductible,
  AncillaryProductsRoadside,
  AncillaryProductsServiceMap,
  DisabledCareEssential,
  DisabledCarePlus,
  DisabledCarePremier,
  Carrot,
  TooltipSmall,
  GapWaiverCar,
  GapWaiverCaution,
  GapWaiverCheck,
  GapWaiverCoverageCheck,
  CalendarIcon,
  AlertCircle,
  CheckCircle,
  OutlineCircle,
  Clock,
  NewGapWaiverCar,
  ShieldCheckMark,
  GetValue,
  CongratsModalAccidentFree,
  CongratsModalDuoCheck,
  CongratsModalPhone,
  HaulerPic,
  VendingMachinePic,
  ThirdPartyDeliveryPic,
  VehicleUnavailable,
  DollarSignIcon,
  MoneyIcon,
  BankIcon,
  ToolTipStandard,
  Refresh,
  Popular,
  SecuredLock,
  ToolTipStandardSvg,
  Pin,
  Delivery,
  Edit,
  Caution,
  SaveOptions,
  BrokenMap,
  VehicleSide,
  EncircledLicense,
  CheckFilled,
  CloseLarge,
  CloseSmall,
  ErrorFilled,
  ErrorOutlined,
  InformationStandard,
  InformationFilled,
  MapMarker,
  Flash,
  Star,
  ArrowLeftSmall,
  ArrowLeftLarge,
  DuoCheck,
  NotarizeLogo,
  ODOExample,
  CarvanaRootInsurance,
  RootLogoGroup,
  GabiLogoGroup,
  ProgressiveLogoGroup,
  UploadInsurance,
  Document,
  Download,
  Fire,
  CheckLarge,
  SendLarge,
  SendSmall,
  Attached,
  CaretRight,
  ArrowDown,
  ToolTipExclamation,
  Money,
  DocError,
  IdIcon,
  DocUploadIcon,
  Lightbulb,
  CautionIco,
  AdjustmentIcon,
  ArrowDownIcon,
  TradeInIcon,
  PeopleIcon,
  SevenDayMoney,
  CoSigner,
  MoneySparkles,
  LocationPin,
  HaveItDeliveredSmall,
  HaveItDeliveredLarge,
  CoastToCoast,
  DottedLine,
  HomeIcon,
  Vending,
  HaulerW231,
  HaulerW365,
  CarvanaCarePlusTerms,
  CoinMoneySignArrows,
  Brackets,
  GreenCheck,
  CaretRightEnabled,
  CaretRightDisabled,
  CaretLeftEnabled,
  CaretLeftDisabled,
  Trash,
  PriceDrop,
  BodyStyle,
  MoneyKeys,
  PurchaseHeaderClock,
  PurchaseHeaderCart,
  ListIcon,
  CarvanaLogoHorizontal,
  CloseIcon16px,
  PdfIcon,
  PhotoIcon
};
